import * as Yup from "yup";

export const addressValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required."),
  lastName: Yup.string().required("Last name is required."),
  address1: Yup.string().required("Address is required."),
  address2: Yup.string(),
  city: Yup.string().required("City is required."),
  state: Yup.string().required("State is required."),
  zipcode: Yup.string().required(
    "Zip code is required. If not applicable, enter '00000'."
  ),
  country: Yup.string().required("Country is required."),
  phoneNumber: Yup.string()
    // .matches(
    //   /^(\+1\d{10})|(\+33\d{9})|(\+237\d{8})$/,
    //   "Phone number must be valid for USA, Canada, France, or Cameroon."
    // )
    .required("Phone number is required."),
  email: Yup.string()
    .email("Invalid email address.")
    .required("Email is required."),
});
